import React, { useEffect, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const TicketsWhatsappSelect = ({ selectedWhatsappId = "", onChange }) => {
	const [whatsapps, setWhatsapps] = useState([]);

	useEffect(() => {
		const fetchWhatsapps = async () => {
			try {
				const { data } = await api.get("/whatsapp");
				setWhatsapps(data || []);
			} catch (err) {
				toastError(err);
			}
		};
		fetchWhatsapps();
	}, []);

	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<div style={{ width: 160, marginTop: -4 }}>
			<FormControl fullWidth margin="dense">
				<Select
					displayEmpty
					variant="outlined"
					value={selectedWhatsappId}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
				>
					<MenuItem dense value="">
						📱 Todas as conexões
					</MenuItem>
					{whatsapps.map(whatsapp => (
						<MenuItem dense key={whatsapp.id} value={whatsapp.id.toString()}>
							📱 {whatsapp.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsWhatsappSelect;
